import { ComponentRef, EmbeddedViewRef, TemplateRef, ViewContainerRef } from '@angular/core';

export class GeofenceStackRouting {
  containerRef: ViewContainerRef;
  private stack: ComponentRef<any>[];
  private embeddedStack: EmbeddedViewRef<any>[] = [];
  private landingContentRef?: TemplateRef<any>;

  constructor(hostViewContainer: ViewContainerRef, landingContentRef?: TemplateRef<any>) {
    this.containerRef = hostViewContainer;
    this.landingContentRef = landingContentRef;
    this.stack = [];
  }

  show(component, options: any): void {
    // hide current top
    if (this.stack.length > 0) {
      if (!options.doNotHide) {
        this.stack[this.stack.length - 1].location.nativeElement.style.display = 'none';
      }

      // hiding the embedded view
      if (this.embeddedStack.length) {
        const node = this.embeddedStack[0].rootNodes.find((n) => n.nodeType === 1) as HTMLElement;

        if (node) node.style.display = 'none';
      }
    }

    // to display landing page
    if (options.data.landingPage) {
      const ref = this.containerRef.createEmbeddedView(this.landingContentRef);
      this.embeddedStack.push(ref);
      return;
    }

    const componentRef = this.containerRef.createComponent(component);
    if (options.data) {
      Object.keys(options.data).forEach((key) => {
        // check to identify the event to subscribe to
        // output:EVENT_NAME i.e @Output in the component
        if (key.startsWith('output:')) {
          const actualkey = key.replace('output:', '');
          const sub = componentRef.instance[actualkey].subscribe((value) => {
            // executing the event function
            options.data[key](value);
          });

          // unsubscribing when the component is destroyed
          componentRef.onDestroy(() => sub.unsubscribe());
        }

        // setting data for @Input present in the component
        // the keys used should be same as the @Input variable name
        componentRef.instance[key] = options.data[key];
      });
    }

    // stacking on top of another
    const el = componentRef.location.nativeElement as HTMLElement;
    el.classList.add('dynamic-layer');
    el.style.zIndex = (1000 + this.stack.length).toString();

    this.stack.push(componentRef);
  }

  pop(options: any) {
    // clears embedded view if exists
    if (options.clearEmbedded) {
      const ref = this.embeddedStack.pop();
      if (ref) ref.destroy();
    }

    // this will remove the current component
    if (this.stack.length > 0) {
      const top = this.stack.pop();
      top?.destroy();

      if (this.stack.length === 0) {
        this.containerRef.clear();
      } else {
        // this block is to show landing page when user click back from create geofence page rather than clicking save
        if (this.embeddedStack.length && this.stack.length === 1) {
          const node = this.embeddedStack[0].rootNodes.find((n) => n.nodeType === 1) as HTMLElement;

          if (node) node.style.display = 'block';
          return;
        }

        this.stack[this.stack.length - 1].location.nativeElement.style.display = 'block';
      }
    }
  }
}
